var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210px",
    height: "210px",
    viewBox: "0 0 210 210",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blocked account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-is-blocked,-deleted-/-Group-/-Products",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-bloked,-deleted-/-4",
    transform: "translate(-1060.000000, -80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(115.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-sidebar",
    transform: "translate(930.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blocked-account"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#808080",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-(1)",
    mask: "url(#mask-2)",
    fill: "#D8D8D8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.622642, 51.509434)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 69.3396226,
    cy: 37.6415094,
    r: 37.6415094
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3584906,95.0943396 C30.1574027,95.0943396 0,123.477777 0,158.490566 L134.716981,158.490566 C134.716981,123.477777 104.559578,95.0943396 67.3584906,95.0943396 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user-(1)",
    mask: "url(#mask-2)",
    fill: "#D8D8D8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.792453, 15.849057)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 67.3584906,
    cy: 35.6603774,
    r: 35.6603774
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3962264,87.1698113 C28.3834379,87.1698113 0,115.553249 0,150.566038 L126.792453,150.566038 C126.792453,115.553249 98.409015,87.1698113 63.3962264,87.1698113 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user-(1)",
    mask: "url(#mask-2)",
    fill: "#D8D8D8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.773585, 39.622642)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 57.4528302,
    cy: 29.7169811,
    r: 29.7169811
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.490566,75.2830189 C23.9485257,75.2830189 0,98.3445621 0,126.792453 L106.981132,126.792453 C106.981132,98.3445621 83.0326064,75.2830189 53.490566,75.2830189 Z",
    id: "Shape"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUnavailable);
export default __webpack_public_path__ + "static/media/group_unavailable.a638910ccd326f9f3f4eef58d6e56785.svg";
export { ForwardRef as ReactComponent };